import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query';
import { filtersApi } from '../api/filters';

export const useFilters = (guildId: string | null) => {
  return useQuery({
    queryKey: ['filters', guildId],
    queryFn: () => filtersApi.getFilters(guildId!),
    enabled: !!guildId,
  });
};

export const useToggleFilter = (guildId: string | null) => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: ({ filterId, enabled }: { filterId: string; enabled: boolean }) =>
      filtersApi.toggleFilter(guildId!, filterId, enabled),
    onMutate: async ({ filterId, enabled }) => {
      // 진행 중인 쿼리 취소
      await queryClient.cancelQueries({ queryKey: ['filters', guildId] });

      // 이전 데이터 스냅샷
      const previousFilters = queryClient.getQueryData(['filters', guildId]);

      // 낙관적 업데이트
      queryClient.setQueryData(['filters', guildId], (old: any) => {
        if (!old || !Array.isArray(old)) return old;
        return old.map((filter: any) =>
          filter.id === filterId ? { ...filter, enabled } : filter
        );
      });

      return { previousFilters };
    },
    onError: (_err, _variables, context) => {
      // 오류 발생 시 롤백
      if (context?.previousFilters) {
        queryClient.setQueryData(['filters', guildId], context.previousFilters);
      }
    },
    onSettled: () => {
      // 성공/실패 관계없이 최종적으로 리프레시
      queryClient.invalidateQueries({ queryKey: ['filters', guildId] });
    },
  });
};
